import { SampleMode } from './sample-mode';
import { DropdownItem } from '../../../../../../shared/dropdown-item';
var SampleModeHelper = /** @class */ (function () {
    function SampleModeHelper() {
    }
    SampleModeHelper.getSampleModes = function () {
        return [
            new DropdownItem(SampleMode.Period, 'PeriodicAcquisition'),
            new DropdownItem(SampleMode.OnChange, 'ChangeAcquisition')
        ];
    };
    return SampleModeHelper;
}());
export { SampleModeHelper };
